import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { round, pick } from 'lodash';
import { bindActionCreators } from 'redux';
import {
  Table,
} from 'react-bootstrap';
import cx from 'classnames';
import UserModal from './UserModal';
import s from '../../../../redux/selectors';
import a from '../../../../redux/actions';
import { wrap, withT, withRouterAndHelpers } from '../../../../lib/wrappers';
import Filters from './Filters';
import types from '../../../../types';
import { displayLocation } from '../../../../lib/locations';
import Paginator from '../../../common/Paginator.tsx';

const quantityHeaders = {
  result_transport_total: 'Transportation',
  result_housing_total: 'Housing',
  result_food_total: 'Food',
  result_goods_total: 'Goods',
  result_services_total: 'Services',
  result_grand_total: 'Total',
};

const displayUserName = user =>
  (user.lastName ?
    `${user.firstName} ${user.lastName}` :
    user.firstName);

const Leaders = ({
  t, leadersQueryResult, calculatorResultLeadersOffset, pageLeaders, setModalLeader,
  currentRoute, leadersFilter, toggleLeadersOrder, defaultLeadersOrder,
}) => (
  <div id="leaders">
    <Filters />
    {leadersQueryResult.totalPages > 1 &&
      <Paginator
        totalPages={leadersQueryResult.totalPages}
        currentPage={leadersQueryResult.currentPage}
        onSelect={page => pageLeaders(currentRoute, page)}
      />
    }
    <Table striped bordered condensed hover>
      <thead>
        <tr>
          <th>#</th>
          <th>{t('Name')}</th>
          <th>{t('Location')}</th>
          <th>{t('Household size')}</th>
          <th
            id={'leaders__sort--pledge_count'}
            onClick={() => toggleLeadersOrder(currentRoute, 'pledge_count')}
            style={{ cursor: 'pointer' }}
          >
            <i
              className={cx('fa', {
                'fa-arrow-down': leadersFilter.orderField === 'pledge_count' && !leadersFilter.orderDesc,
                'fa-arrow-up': leadersFilter.orderField === 'pledge_count' && leadersFilter.orderDesc,
              })}
            />
            {t('Pledges')}
          </th>
          <th
            id={'leaders__sort--footprint'}
            onClick={() => toggleLeadersOrder(currentRoute, '')}
            style={{ cursor: 'pointer' }}
          >
            <i
              className={cx('fa', {
                'fa-arrow-down': leadersFilter.orderField !== 'pledge_count' && !leadersFilter.orderDesc,
                'fa-arrow-up': leadersFilter.orderField !== 'pledge_count' && leadersFilter.orderDesc,
              })}
            />
            <span
              dangerouslySetInnerHTML={{
                __html: `${t('{{category}} tons CO<sub>2</sub>eq', { category: t(quantityHeaders[defaultLeadersOrder]) })}`,
              }}
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {leadersQueryResult.pages[leadersQueryResult.currentPage].map((user, i) => (
          <tr
            key={user.id}
            style={{ cursor: 'pointer' }}
            onClick={() => setModalLeader(user)}
          >
            <td>{calculatorResultLeadersOffset + i + 1}</td>
            <td>{displayUserName(user)}</td>
            <td>{displayLocation(user)}</td>
            <td>{user.input_size}</td>
            <td className="leaders__row--pledge_count">{user.pledgeCount}</td>
            <td className="leaders__row--footprint">{round(user[defaultLeadersOrder], 2)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
    {leadersQueryResult.totalPages > 1 &&
      <Paginator
        totalPages={leadersQueryResult.totalPages}
        currentPage={leadersQueryResult.currentPage}
        onSelect={page => pageLeaders(currentRoute, page)}
      />
    }
    <UserModal />
  </div>
);

Leaders.propTypes = {
  t: PropTypes.func.isRequired,
  setModalLeader: PropTypes.func.isRequired,
  pageLeaders: PropTypes.func.isRequired,
  leadersQueryResult: types.LeadersQueryResult.isRequired,
  leadersFilter: types.LeadersFilter.isRequired,
  currentRoute: PropTypes.string.isRequired,
  defaultLeadersOrder: PropTypes.string.isRequired,
  calculatorResultLeadersOffset: PropTypes.number.isRequired,
  toggleLeadersOrder: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'leadersQueryResult',
  'leadersFilter',
  'defaultLeadersOrder',
  'calculatorResultLeadersOffset',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'pageLeaders',
    'setModalLeader',
    'toggleLeadersOrder',
  ]),
  dispatch,
);

export default wrap(
  withT('leaders'),
  withRouterAndHelpers,
  connect(mapStateToProps, mapDispatchToProps)(Leaders),
);

